<template>
  <div class="rulesRegulationsUp mainPageBg">
    <div class="upContent">
      <div class="uploadBox">
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="addBtn"
          >新增{{ page }}</el-button
        >
      </div>
      <div class="listBox commonWrap">
        <template v-if="list.length">
          <div class="leftMenu">
            <PublicListCom :list="list" @getActiveTitle="getActiveTitle" />
          </div>
          <div class="rightContent">
            <div class="operation">
              <h3>{{ detailsData.title }}</h3>
              <div>
                <el-button
                  type="primary"
                  icon="el-icon-delete"
                  size="mini"
                  @click="handleClose"
                ></el-button>
                <el-button
                  type="primary"
                  icon="el-icon-edit"
                  size="mini"
                  @click="editBtn"
                ></el-button>
              </div>
            </div>
            <iframe :src="contentData" width="100%"></iframe>
          </div>
        </template>
        <template v-else>
          <el-empty
            :description="'暂无' + page"
            style="margin: 0 auto"
          ></el-empty>
        </template>
      </div>
    </div>
    <AddEditDialog
      v-if="dialogVisible"
      :dialogVisible="dialogVisible"
      :title="title"
      :page="page"
    />
  </div>
</template>

<script>
import PublicListCom from "@/components/guanlizhidu/PublicListCom";
import AddEditDialog from "@/components/guanlizhidu/AddEditDialog";
import api from "@/api";
import axios from "axios";
export default {
  components: {
    PublicListCom,
    AddEditDialog,
  },
  data() {
    return {
      deleteData: false,
      page: "",
      list: [],
      detailsData: {},
      dialogVisible: false,
      title: "新增制度",
      contentData: null,
      objType: "application/pdf",
      active: 0,
      httpUrl: "",
      tokenString: "",
    };
  },
  watch: {
    $route: function () {
      if (this.$route.path == "/rulesRegulationsUp") {
        this.page = "规章制度";
      } else if (this.$route.path == "/operateUp") {
        this.page = "运营要求";
      }
      this.getList();
    },
  },
  methods: {
    async getActiveTitle(data) {
      this.detailsData = data.item;
      let index = data.item.uri.lastIndexOf("/");
      let str = data.item.uri.substring(index + 1, data.item.uri.length);
      axios({
        method: "get",
        url:
          this.httpUrl +
          "/api/juji/filesvc/local/view/" +
          str +
          "?tenant_id=" +
          JSON.parse(window.sessionStorage.getItem("userInfo")).tenantId,
        headers: {
          Accept: "*/*",
          "X-Authorization": `Bearer ${this.tokenString}`,
        },
        responseType: "arraybuffer",
      })
        .then((res) => {
          if (res.status == 200 && res.data) {
            const fileData = res.data;
            const tempUrl = window.URL.createObjectURL(
              new Blob([fileData], {
                type: res.headers["content-type"],
              })
            );
            this.contentData = tempUrl;
          }
        })
        .catch(function (error) {});
    },
    handleClose() {
      this.$confirm(`确定删除此${this.page}?`, "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        callback: (action) => {
          if (action === "confirm") {
            // console.log(this.detailsData);
            axios
              .post(
                this.httpUrl +
                  `/api/juji/project/rules/delete?projectIdStr=${
                    JSON.parse(window.sessionStorage.getItem("userInfo")).projects[0].projectId
                  }&category=${this.page}&startTs=${
                    this.detailsData.ts
                  }&endTs=${this.detailsData.ts + 1}&deleteFileToo=true`,
                this.detailsData.uri,
                {
                  headers: {
                    "Content-Type": "application/json ",
                    "X-Authorization": `Bearer ${this.tokenString}`,
                  },
                }
              )
              .then((res) => {
                if (res && res.status == 200) {
                  this.$message({
                    type: "success",
                    message: "删除成功!",
                  });
                  this.getList();
                }
              });
          }
        },
      });
    },

    addBtn() {
      this.dialogVisible = true;
      this.title = "新增制度";
      this.page == "规章制度"
        ? (this.title = "新增制度")
        : (this.title = "新增运营要求");
    },
    editBtn() {
      this.dialogVisible = true;
      this.title = "编辑";
    },
    async getList() {
      this.list = [];
      this.active = 0;
      let res = await api.systemGetList({
        projectIdStr: JSON.parse(window.sessionStorage.getItem("userInfo")).projects[0].projectId,
        category: this.page,
        startTs: 0,
        endTs: new Date().getTime(),
      });
      // console.log(res);
      if (res.status == 200) {
        this.list = res.data;
        if (this.list.length) {
          let data = {
            item: this.list[0],
            index: 0,
          };
          this.getActiveTitle(data);
        }
      }
    },
  },
  created() {
    this.httpUrl = window.jujiParams.baseURL;
    this.tokenString = window.sessionStorage.getItem("token");
    if (this.$route.path == "/rulesRegulationsUp") {
      this.page = "规章制度";
    } else if (this.$route.path == "/operateUp") {
      this.page = "运营要求";
    }
    this.getList();
  },
};
</script>


<style lang="scss" scoped>
.rulesRegulationsUp {
  @include setFlexCenter;
  .upContent {
    width: 96%;
    height: 100%;
    @include setFlexColumn;
    align-items: center;
    justify-content: space-around;
    .uploadBox {
      width: 100%;
      height: 55px;
      display: flex;
      justify-content: flex-end;
      align-items: flex-end;
    }
    .listBox {
      width: 100%;
      height: calc(100% - 100px);
      box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
      @include setFlexBetween;
      .leftMenu {
        width: 22%;
        height: 96%;
        overflow: hidden;
      }
      .leftMenu:hover {
        overflow-y: auto;
      }
      .rightContent {
        width: 76%;
        height: 96%;
        margin: 0 auto;
        .operation {
          height: 80px;
          width: 100%;
          @include setFlexBetween;
          h3 {
            height: 80px;
            text-indent: 20px;
            line-height: 80px;
            font-size: 26px;
          }
        }

        iframe {
          height: calc(100% - 80px);
        }
      }
    }
  }
}
</style>